import { render, staticRenderFns } from "./PractitionerCard.vue?vue&type=template&id=2254bdd9&scoped=true"
import script from "./PractitionerCard.vue?vue&type=script&lang=js"
export * from "./PractitionerCard.vue?vue&type=script&lang=js"
import style0 from "./PractitionerCard.vue?vue&type=style&index=0&id=2254bdd9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2254bdd9",
  null
  
)

export default component.exports